import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=3e7a081a&scoped=true"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"
import style0 from "./BugReport.vue?vue&type=style&index=0&id=3e7a081a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a081a",
  null
  
)

export default component.exports